module.exports = __webpack_public_path__ + "static/img/popup-200904-2.cf0a651.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/locale/ko/images/popup-200904-2.jpg
// module id = 37qS
// module chunks = 25